import { memo, useCallback } from 'react';
import { Tab } from '@aimsos/ui';

/**
 * One tab of the People & Access header. Memoized so switching tabs only re-renders
 * the tabs whose `selected` flag changed.
 *
 * @param {object} props
 * @param {string} props.id Route segment of the tab.
 * @param {string} props.label Already translated label.
 * @param {boolean} props.selected
 * @param {(id: string) => void} props.onSelect
 */
function PeopleAccessTab({ id, label, selected, onSelect }) {
  const handleClick = useCallback(() => onSelect(id), [id, onSelect]);

  return (
    <Tab size="sm" selected={selected} onClick={handleClick}>
      {label}
    </Tab>
  );
}

export default memo(PeopleAccessTab);
